import React, { PropTypes, Component } from 'react';
import { isEmpty } from 'lodash';
import { NitroLoading } from 'nitro-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as routes from '../routes/const';
import * as actions from './actions';
import { getCurrentRole } from '../components/common/Profile/selector';
import { updateSessionStorage } from './persistance';
import auth0Login from '../utils/auth0/login';

const stripLeadingSlash = str => {
  if (!str) return null;

  return str.indexOf('/') === 0 ? str.substring(1) : str;
};

const isAuthorized = (requestedPath, allowedPaths) => {
  if (!allowedPaths) return false;
  for (let path of allowedPaths) {
    path = stripLeadingSlash(path);
    if (requestedPath.includes(path)) return true;
  }

  return false;
};

export default function(ComposedComponent) {
  class CanView extends Component {
    /**
     * Checking access to this component involves 3 sequential steps
     *
     * 1  is the user authenticated (do they have a token)
     *      if there is a token stored, we treat them as authed until proven
     *      otherwise, if not we bump them out to login
     * 2  if thy have a token, do they have a config?
     *      if they dont have a config set, then they are probably accessing
     *      this resource directly, so we need to fetch their config
     *      if the token from step 1 is invalid, the token will be removed
     *      and on component update, step 1 will now fail
     * 3  finally, are they authorized to view this resource?
     *      if not, we bump them out to their default view
     */

    // Do step 1
    componentWillMount() {
      const {
        isAuthenticated,
        defaultView,
        acl,
        location,
        hasConfig
      } = this.props;
      const { router } = this.context;
      if (!isAuthenticated) {
        const path = location.pathname;
        if (path === '/') {
          router.push(routes.LOGIN);
        } else {
          sessionStorage.setItem('targetUrl', path);
          auth0Login(path);
        }
      } else {
        const roleId = sessionStorage.getItem('roleId');
        this.props.actions.fetchConfig(roleId).then(state => {
          const role = getCurrentRole(state);
          if (role) {
            updateSessionStorage(role.value, role.label);
          }
        });
      }
    }

    /* componentDidMount() {
      this.checkAccess(this.props);
    } */

    componentWillReceiveProps(nextProps) {
      const { router } = this.context;
      const { location, acl, defaultView, isAuthenticated } = nextProps;
      const isUnauthenticated = !isAuthenticated || (isAuthenticated && !localStorage.getItem('auth/token'));
      if (isUnauthenticated) {
        return router.push(routes.LOGIN);
      }
      const targetUrl = stripLeadingSlash(sessionStorage.getItem('targetUrl'));
      const pathname = stripLeadingSlash(location.pathname);
      if (targetUrl && isAuthorized(targetUrl, acl)) {
        sessionStorage.removeItem('targetUrl');
        router.push(`${targetUrl}`);
      } else if (!isAuthorized(pathname, acl)) {
        router.push(`${defaultView}`);
      }
    }

    render() {
      const { hasConfig } = this.props;
      if (!hasConfig) return <NitroLoading screen />;
      return <ComposedComponent {...this.props} />;
    }
  }

  CanView.contextTypes = {
    router: PropTypes.object
  };

  CanView.propTypes = {
    hasConfig: PropTypes.bool.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    acl: PropTypes.array,
    defaultView: PropTypes.string,
    location: PropTypes.object,
    actions: PropTypes.object
  };

  const mapStateToProps = state => ({
    hasConfig: !isEmpty(state.auth.config),
    isAuthenticated: state.auth.isAuthenticated,
    acl: state.auth.config.acl,
    defaultView: state.auth.config.defaultView
  });

  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch)
  });

  return connect(mapStateToProps, mapDispatchToProps)(CanView);
}



// WEBPACK FOOTER //
// ./src/auth/CanView.js